import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modals
import ActionsChatBotCrud from "./Modals/ActionsChatBotCrud";
import ConfirmModal from "@Modals/ConfirmModal";

// Styles
import styles from "./styles.module.css";

const Roles = ({ dispatch, userName, companyName }) => {
	const [tableValue, setTableValue] = useState({});
	const [openCrud, setOpenCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [modalOption, setModalOption] = useState("");
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	// const [menuData, setMenuData] = useState([]);

	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const rolesPromise = dataHandler({
				dispatch,
				url: "actions",
				params: defaultParams,
			});
			const [rolesResponse] = await Promise.all([rolesPromise]);
			setFilteredCount(rolesResponse.count);
			setFilteredItems(rolesResponse.items);
		})();
	}, []);

	// modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenCrud(true);
	};

	// table Handler

	const handleButton = async (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, []);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `actions/${tableValue.id}` }));
				refresh();
				break;
			default:
				break;
		}
	};

	// data handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "actions", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const profilesResponse = await dataHandler({
			dispatch,
			url: "actions",
			params: defaultParams,
		});
		setFilteredCount(profilesResponse.count);
		setFilteredItems(profilesResponse.items);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Acciones ChatBot">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{ label: "ID", key: "id", format: "string", dataPosition: "center", width: 1 },
								{ label: "Compañía ID", key: "companyId", format: "string", dataPosition: "center", width: 1 },
								{ label: "Nombre", key: "name", format: "string", dataPosition: "center", width: 1 },
								{ label: "Método", key: "method", format: "string", dataPosition: "center", width: 1 },
								{ label: "Tipo", key: "type", format: "string", headerPosition: "left", width: 16 },
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButton}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem" }}
							print={{ printHeader: { company: companyName, title: "Acciones ChatBot", user: userName } }}
						/>
					</div>
				</div>
			</div>
			{openCrud && (
				<ActionsChatBotCrud
					tableValue={tableValue}
					refresh={refresh}
					onClose={() => {
						setOpenCrud(false);
					}}
					modalCrud={modalOption}
				/>
			)}
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar la Acción"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		userName: user.fullName,
		companyName: company.name,
	};
}

Roles.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
};
export default connect(mapStateToProps)(Roles);
